// removed by extract-text-webpack-plugin
module.exports = {"field-list":"field-list__field-list___kR1Ri","field-list-item":"field-list__field-list-item___2ifat","field-list-no-wildcards":"field-list__field-list-no-wildcards___3fmnD"};